module.exports = __webpack_public_path__ + "mtoto.png?e30047aa19745005a91ce9d6bbbe01f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/mtoto.png
// module id = 123
// module chunks = 0